import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { Event } from '@jd/jmtd-tools/es/event';
import { isFunction } from '@jd/jmtd-tools/es/is';
import { forOwn, empty } from '@jd/jmtd-tools/es/object';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var INIT = Symbol('init');
var SET_STATE = Symbol('setState');
var requestIdle = window.requestAnimationFrame ? function (task) {
  return window.requestAnimationFrame(task);
} : function (task) {
  return window.setTimeout(task, 0);
};

function createStore() {
  var reducer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var subscribers = Event();
  var state = {};
  var cache = {};
  var callReducers;
  var stack = 0;
  var reduceEndTasks = [];
  var subscribersNeedTriggered = false;
  var dispatch;

  function getState() {
    return state;
  }

  function setState(_x, _x2) {
    return _setState.apply(this, arguments);
  }

  function _setState() {
    _setState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(nextState, actionType) {
      var changedState, triggerSubscribe, todo, _iterator, _step, task;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              triggerSubscribe = function _triggerSubscribe() {
                if (subscribersNeedTriggered) {
                  subscribers.trigger(state);
                }
              };

              changedState = {};
              subscribersNeedTriggered = true;
              ++stack;

              // 处理函数
              if (isFunction(nextState)) {
                nextState = nextState(state);
              }

              forOwn(nextState, function (_, key) {
                changedState[key] = true;
              }, true);
              state = _objectSpread$4(_objectSpread$4({}, state), nextState);
              requestIdle(triggerSubscribe);
              _context2.next = 10;
              return callReducers({
                actionType: actionType,
                changedState: changedState
              });

            case 10:
              if (!(--stack === 0)) {
                _context2.next = 31;
                break;
              }

              if (!reduceEndTasks) {
                _context2.next = 31;
                break;
              }

              todo = reduceEndTasks.concat([]);
              reduceEndTasks = [];
              _iterator = _createForOfIteratorHelper(todo);
              _context2.prev = 15;

              _iterator.s();

            case 17:
              if ((_step = _iterator.n()).done) {
                _context2.next = 23;
                break;
              }

              task = _step.value;
              _context2.next = 21;
              return task();

            case 21:
              _context2.next = 17;
              break;

            case 23:
              _context2.next = 28;
              break;

            case 25:
              _context2.prev = 25;
              _context2.t0 = _context2["catch"](15);

              _iterator.e(_context2.t0);

            case 28:
              _context2.prev = 28;

              _iterator.f();

              return _context2.finish(28);

            case 31:
              if (stack === 0) {
                // 触发订阅
                triggerSubscribe();
                subscribersNeedTriggered = false;
              }

            case 32:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[15, 25, 28, 31]]);
    }));
    return _setState.apply(this, arguments);
  }

  callReducers = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return reducer(_objectSpread$4({
                dispatch: dispatch,
                getState: getState,
                setState: setState,
                changedState: {},
                cache: cache,
                onReduceEnd: function onReduceEnd(task) {
                  reduceEndTasks.push(task);
                }
              }, args));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function callReducers(_x3) {
      return _ref.apply(this, arguments);
    };
  }();

  dispatch = function dispatch(actionType, actionData) {
    if (actionType === SET_STATE) {
      setState(actionData);
    } else {
      // 初始时清空context
      if (actionType === INIT) {
        empty(cache);
      }

      callReducers({
        actionType: actionType,
        actionData: actionData
      });
    }
  };

  dispatch(INIT);
  return {
    getState: getState,
    setState: setState,
    dispatch: dispatch,
    subscribe: function subscribe(task) {
      return subscribers.register(task).remove;
    }
  };
}

var ASYNC_CACHE = Symbol('asyncCache');
var DEFAULT_CACHE = Symbol('defaultCache');

function async(cache, fetcher) {
  var cacheKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CACHE;
  cache[ASYNC_CACHE] = cache[ASYNC_CACHE] || {};
  var promise = cache[ASYNC_CACHE][cacheKey] = fetcher().then(function (result) {
    var _cache$ASYNC_CACHE;

    if ((cache === null || cache === void 0 ? void 0 : (_cache$ASYNC_CACHE = cache[ASYNC_CACHE]) === null || _cache$ASYNC_CACHE === void 0 ? void 0 : _cache$ASYNC_CACHE[cacheKey]) === promise) {
      return [true, result];
    }

    return [false];
  }).catch(function (e) {
    var _cache$ASYNC_CACHE2;

    if ((cache === null || cache === void 0 ? void 0 : (_cache$ASYNC_CACHE2 = cache[ASYNC_CACHE]) === null || _cache$ASYNC_CACHE2 === void 0 ? void 0 : _cache$ASYNC_CACHE2[cacheKey]) === promise) {
      throw e;
    }

    return [false];
  });
  return promise;
}

var _excluded$3 = ["cache", "getState", "setState"];

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var FETCH_STATE = Symbol('fetchState');
var FETCH_START = Symbol('fetchStart');
var FETCH_END = Symbol('fetchEnd');
var FETCH_ERROR = Symbol('fetchError'); // 判断2个key是否相等

function isKeyEqual(oldKey, newKey) {
  if (Array.isArray(oldKey)) {
    if (!Array.isArray(newKey)) {
      return false;
    }

    if (oldKey.length !== newKey.length) {
      return false;
    }

    return oldKey.every(function (item, i) {
      return item === newKey[i];
    });
  }

  return oldKey === newKey;
}

function _fetch(_ref, callback) {
  var _ref5;

  var state = _ref.state,
      $state = _ref.$state,
      fetcher = _ref.fetcher,
      key = _ref.key,
      cache = _ref.cache,
      force = _ref.force;

  var _ref2 = state !== null && state !== void 0 ? state : {},
      data = _ref2.data,
      lastKey = _ref2.key;

  if (!force && key && isKeyEqual(lastKey, key)) {
    return null;
  }

  async(cache, fetcher, $state).then(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        effective = _ref4[0],
        result = _ref4[1];

    if (effective) {
      var _callback;

      callback(null, (_callback = {}, _defineProperty(_callback, FETCH_STATE, true), _defineProperty(_callback, "key", key), _defineProperty(_callback, "error", null), _defineProperty(_callback, "data", result), _defineProperty(_callback, "loading", false), _callback));
    }
  }).catch(function (e) {
    var _callback2;

    callback(e, (_callback2 = {}, _defineProperty(_callback2, FETCH_STATE, true), _defineProperty(_callback2, "key", key), _defineProperty(_callback2, "error", e), _defineProperty(_callback2, "loading", false), _callback2));
  });
  return _ref5 = {}, _defineProperty(_ref5, FETCH_STATE, true), _defineProperty(_ref5, "key", key), _defineProperty(_ref5, "loading", true), _defineProperty(_ref5, "data", data), _ref5;
}

function fetchMiddleware(reducer) {
  return function (_ref6) {
    var cache = _ref6.cache,
        getState = _ref6.getState,
        setState = _ref6.setState,
        otherArg = _objectWithoutProperties(_ref6, _excluded$3);

    return reducer(_objectSpread$3(_objectSpread$3({
      cache: cache,
      getState: getState,
      setState: setState
    }, otherArg), {}, {
      fetch: function fetch($state, fetcher, key) {
        var _getState;

        var state = (_getState = getState()) === null || _getState === void 0 ? void 0 : _getState[$state];

        var result = _fetch({
          cache: cache,
          state: state,
          $state: $state,
          fetcher: fetcher,
          key: key
        }, function (error, nextState) {
          setState(_defineProperty({}, $state, nextState), error ? FETCH_ERROR : FETCH_END);
        });

        if (result) {
          setState(_defineProperty({}, $state, result), FETCH_START);
        }
      }
    }));
  };
}

function compose() {
  for (var _len = arguments.length, list = new Array(_len), _key = 0; _key < _len; _key++) {
    list[_key] = arguments[_key];
  }

  return function (arg) {
    return list.reduce(function (total, cur) {
      return cur(total);
    }, arg);
  };
}

var _excluded$2 = ["cache", "onReduceEnd"];

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var REDUCE_END_REQUESTED = Symbol('reduceEndRequested');

function requestReduceEndMiddleware(reducer) {
  return function (_ref) {
    var cache = _ref.cache,
        onReduceEnd = _ref.onReduceEnd,
        otherArg = _objectWithoutProperties(_ref, _excluded$2);

    return reducer(_objectSpread$2(_objectSpread$2({
      cache: cache,
      onReduceEnd: onReduceEnd
    }, otherArg), {}, {
      requestReduceEnd: function requestReduceEnd(task) {
        var stateName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : REDUCE_END_REQUESTED;

        if (!cache[stateName]) {
          onReduceEnd(function () {
            cache[stateName] = false;
            task();
          });
          cache[stateName] = true;
          return true;
        }

        return false;
      }
    }));
  };
}

var _excluded$1 = ["cache"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function combineReducers() {
  for (var _len = arguments.length, reducers = new Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
      var cache, other;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              cache = _ref.cache, other = _objectWithoutProperties(_ref, _excluded$1);
              _context2.next = 3;
              return reducers.map( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(reducer, index) {
                  var _cache$index;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return reducer(_objectSpread$1({
                            cache: (_cache$index = cache[index]) !== null && _cache$index !== void 0 ? _cache$index : cache[index] = {}
                          }, other));

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2, _x3) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function diff(state, nextState) {
  var diffed = {};
  var hasDiff = false;
  forOwn(nextState, function (value, key) {
    if (state[key] !== value) {
      diffed[key] = value;
      hasDiff = true;
    }
  });
  return [hasDiff, diffed];
}

function DefaultState(defaultState) {
  return function (_ref) {
    var setState = _ref.setState,
        actionType = _ref.actionType;

    if (actionType === INIT) {
      setState(defaultState);
    }
  };
}

var _excluded = ["getState", "changedState", "cache"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DERIVED = Symbol('derived');
function derivedMiddleware(derivedMap, reducer) {
  return function (_ref) {
    var _cache$DERIVED;

    var _getState = _ref.getState,
        changedState = _ref.changedState,
        cache = _ref.cache,
        others = _objectWithoutProperties(_ref, _excluded);

    var derivedStatesCache = (_cache$DERIVED = cache[DERIVED]) !== null && _cache$DERIVED !== void 0 ? _cache$DERIVED : cache[DERIVED] = {};
    forOwn(derivedMap, function (_ref2, derivedStateName) {
      var _ref2$deps = _ref2.deps,
          deps = _ref2$deps === void 0 ? [] : _ref2$deps;
      deps.forEach(function (depStateName) {
        if (changedState[depStateName]) {
          delete derivedStatesCache[derivedStateName];
        }
      });
    }, true);
    reducer(_objectSpread({
      changedState: changedState,
      cache: cache,
      getState: function getState() {
        var result = _objectSpread({}, _getState());

        forOwn(derivedMap, function (_ref3, derivedStateName) {
          var _get = _ref3.get;
          Object.defineProperty(result, derivedStateName, {
            get: function get() {
              var _derivedStatesCache$d;

              if (Object.prototype.hasOwnProperty.call(derivedStatesCache, derivedStateName)) {
                return derivedStatesCache[derivedStateName];
              }

              (_derivedStatesCache$d = derivedStatesCache[derivedStateName]) !== null && _derivedStatesCache$d !== void 0 ? _derivedStatesCache$d : derivedStatesCache[derivedStateName] = _get(result);
              return derivedStatesCache[derivedStateName];
            }
          });
        }, true);
        return result;
      }
    }, others));
  };
}

export { DefaultState, FETCH_END, FETCH_ERROR, FETCH_START, FETCH_STATE, INIT, SET_STATE, async, combineReducers, compose, createStore, derivedMiddleware, diff, _fetch as fetch, fetchMiddleware, requestReduceEndMiddleware };
